import { CollectionAuthorType } from '../../users/types';

export const getAuthorRole = (authorType?: CollectionAuthorType) => {
    switch (authorType) {
        case 'user':
            return 'Пользователь';
        case 'blogger':
            return 'Автор';
        default:
            return '';
    }
};
